import { useMutation } from "@tanstack/react-query";

import { saveInclusiveEducationFeedbackApiCall } from "./utils.api";

export const useSaveInclusiveEducationFeedbackAnswers = () =>
  useMutation({
    mutationFn: (body) => saveInclusiveEducationFeedbackApiCall(body),
  });
